import Controller from '@ember/controller';
import SubjectModel from 'cio/models/subject';
import { inject as service } from '@ember/service';
import AuthService from 'cio/services/auth';
import AlertsService from 'cio/services/alerts';
import { task } from 'ember-concurrency';
import { prettyJSONStringify } from 'cio/utils/objects';

export default class CampaignOverviewSubjectsSubjectController extends Controller {
  @service alerts!: AlertsService;
  @service auth!: AuthService;

  declare model: SubjectModel;

  get hasReadOnlyPermission() {
    if (this.model.campaign.isApiTriggered) {
      return !this.auth.hasPermission('journeys/broadcasts/edit');
    }

    return !this.auth.hasPermission('journeys/campaigns/edit');
  }

  get hasWebhookDataString() {
    return this.webhookDataString.trim() !== '';
  }

  get webhookDataString() {
    if (this.model.eventData == null) {
      return '';
    }

    return prettyJSONStringify(this.model.eventData.attrs);
  }

  get canForceExit() {
    return this.model.isActive || this.model.isStarting;
  }

  forceExitSubjectTask = task({ drop: true }, async () => {
    await this.model.forceExit({});
    await this.model.reload();

    this.alerts.success('subject.forceExit.success', 'This journey has been ended');
  });
}
